export default __webpack_public_path__ + "static/media/004-A-dgfip.457a4230.png";